import { computed } from 'vue';

export function useEsMenorDeEdad(birthday) {
    const calculateAge = birthDate => {
        if (!birthDate) return null;

        const today = new Date();
        const birth = new Date(birthDate);
        let age = today.getFullYear() - birth.getFullYear();
        const monthDiff = today.getMonth() - birth.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
            age--;
        }

        return age;
    };

    const age = computed(() => calculateAge(birthday.value));
    const isMinor = computed(() => age.value !== null && age.value < 18);

    return {
        age,
        isMinor,
        calculateAge
    };
}
